export const GET_STATUS_WATCHER = "app/ReportAmbassador/GET_STATUS_WATCHER"
export const GET_STATUS_SUCCESS = "app/ReportAmbassador/GET_STATUS_SUCCESS"
export const GET_STATUS_FAILED = "app/ReportAmbassador/GET_STATUS_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/ReportAmbassador/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/ReportAmbassador/GET_MEASURE_COLOR_RANGE_SUCCESS"
export const GET_MEASURE_COLOR_RANGE_FAILED =
  "app/ReportAmbassador/GET_MEASURE_COLOR_RANGE_FAILED"

export const GET_MEASURE_TOTAL_WATCHER =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_WATCHER"
export const GET_MEASURE_TOTAL_SUCCESS =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_SUCCESS"
export const GET_MEASURE_TOTAL_FAILED =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_FAILED"

export const GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER"
export const GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS"
export const GET_MEASURE_TOTAL_SUB_DIVISION_FAILED =
  "app/ReportAmbassador/GET_MEASURE_TOTAL_SUB_DIVISION_FAILED"

export const GET_MEASURE_INFO_WATCHER =
  "app/ReportAmbassador/GET_MEASURE_INFO_WATCHER"
export const GET_MEASURE_INFO_SUCCESS =
  "app/ReportAmbassador/GET_MEASURE_INFO_SUCCESS"
export const GET_MEASURE_INFO_FAILED =
  "app/ReportAmbassador/GET_MEASURE_INFO_FAILED"
